import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Card, Container, Dimmer, Page } from "tabler-react";
import moment from "moment";

import { Backend } from "../services";
import WhatsAppMessage from "../components/WhatsAppMessage";

// Campos que o mastra grava no metadata da thread para a equipe de vendas.
const DETAILS = [
  ["nomePerfilWhatsApp", "Nome no WhatsApp"],
  ["empreendimento", "Empreendimento"],
  ["protocolo", "Protocolo"],
  ["perfilInteresse", "Perfil"],
  ["cidadeLead", "Cidade"],
  ["visitaDia", "Visita (dia)"],
  ["visitaPeriodo", "Visita (período)"],
  ["etapaAtendimento", "Etapa"],
];

const formatDate = (value) => (value ? moment(value).format("DD/MM/YYYY [às] HH:mm") : "");

const bubbleStyle = (fromClient) => ({
  maxWidth: "75%",
  padding: "8px 12px",
  borderRadius: 8,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  background: fromClient ? "#ffffff" : "#dcf8c6",
  boxShadow: "0 1px 1px rgba(0, 0, 0, 0.1)",
});

// Tela pública (sem login) de uma conversa do agente de IA, linkada no e-mail do Zapier.
function ConversationPage() {
  const { threadId } = useParams();
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token");

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    Backend.getPublicConversation(threadId, token)
      .then((res) => setData(res.data))
      .catch((err) => {
        const status = err && err.response && err.response.status;
        setError(
          status === 401
            ? "Link inválido ou expirado."
            : status === 404
            ? "Conversa não encontrada."
            : "Não foi possível carregar a conversa."
        );
      });
  }, [threadId, token]);

  const thread = data && data.thread;
  const metadata = (thread && thread.metadata) || {};
  const details = DETAILS.filter(([key]) => metadata[key]);

  return (
    <Page>
      <Container style={{ maxWidth: 820, paddingTop: 24, paddingBottom: 24 }}>
        <Page.Header
          title={`Conversa com ${metadata.nomePerfilWhatsApp || (thread && thread.resourceId) || "cliente"}`}
        />

        {error && <div className="alert alert-danger">{error}</div>}

        {!data && !error && <Dimmer active loader />}

        {data && (
          <>
            <Card>
              <Card.Body>
                <div
                  style={{
                    background: "#e8f0fe",
                    border: "1px solid #0b57d0",
                    borderRadius: 6,
                    padding: "8px 12px",
                    marginBottom: 12,
                  }}
                >
                  <strong>Link desta conversa:</strong>{" "}
                  <a href={window.location.href} style={{ color: "#0b57d0", fontWeight: 600, wordBreak: "break-all" }}>
                    {window.location.href}
                  </a>{" "}
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={() => navigator.clipboard && navigator.clipboard.writeText(window.location.href)}
                  >
                    Copiar
                  </button>
                </div>
                <div>
                  <strong>Telefone:</strong> {thread.resourceId}
                </div>
                <div>
                  <strong>Início:</strong> {formatDate(thread.createdAt)}
                </div>
                {details.map(([key, label]) => (
                  <div key={key}>
                    <strong>{label}:</strong> {metadata[key]}
                  </div>
                ))}
              </Card.Body>
            </Card>

            <Card>
              <Card.Body style={{ background: "#ece5dd" }}>
                {data.messages.length === 0 && <div className="text-muted">Nenhuma mensagem.</div>}

                {data.messages.map((message) => {
                  const fromClient = message.role === "user";

                  return (
                    <div
                      key={message.id}
                      style={{
                        display: "flex",
                        justifyContent: fromClient ? "flex-start" : "flex-end",
                        marginBottom: 12,
                      }}
                    >
                      <div style={bubbleStyle(fromClient)}>
                        <div className="small text-muted">
                          {fromClient ? "Cliente" : "Gi"} · {formatDate(message.createdAt)}
                        </div>
                        <WhatsAppMessage text={message.text} />
                      </div>
                    </div>
                  );
                })}
              </Card.Body>
            </Card>
          </>
        )}
      </Container>
    </Page>
  );
}

export default ConversationPage;
